/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import dayjs from 'dayjs'
import { getInOutLog } from '@/model/storage/inventory'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
    header: false,
  },
  name: {
    displayName: 'resourceName',
  },
  createdAt: {
    type: IKDataEntity.Types.Date,
  },
  priceLiteral: {
    displayName: '入库价格',
    type: IKDataEntity.Types.Float,
  },
  amount: {
    displayName: '操作数量',
    type: IKDataEntity.Types.Integer,
  },
  note: {},
  operation: {},
}


const config = {
  load: async function (filter) {
    console.log(filter)
    const [dateTimeFrom, dateTimeTo] = getZBonTimeLimit(...filter[0].dateFilter)
    const arr = await getInOutLog(dateTimeFrom, dateTimeTo)
    return arr.map(it => {
      return {
        ...it.changeLog,
        name: it.dishResource.dishResource.name,
        ...it,
      }
    })
  },
}

export function getZBonTimeLimit (start, end) {
  const dStart = dayjs(start).startOf('d').add(3, 'hour').add(59, 'minute').toISOString()
  const dEnd = dayjs(end).endOf('d').add(3, 'hour').add(59, 'minute').toISOString()
  return [dStart, dEnd]
}

export default IKDataEntity.ModelFactory(entity, config)
